"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
const indicator_pulse_cjs_1 = require("./indicator.pulse.cjs");
/**
 * Indicator web component
 * @public
 */
class Component extends HTMLElement {
    constructor() {
        super(...arguments);
        /**
         * Component name
         * @public
         */
        this.name = `bud-activity-indicator`;
        /**
         * Status indicator colors
         * @public
         */
        this.colors = {
            success: [4, 120, 87],
            error: [220, 38, 38],
            warn: [252, 211, 77],
            pending: [59, 130, 246],
        };
    }
    /**
     * Get accessor: has errors
     * @public
     */
    get hasErrors() {
        return this.getAttribute('has-errors') == 'true';
    }
    /**
     * Get accessor: has warnings
     * @public
     */
    get hasWarnings() {
        return this.getAttribute('has-warnings') == 'true';
    }
    /**
     * Render status indicator
     * @public
     */
    render() {
        this.classList.add(this.name);
        this.innerHTML = `
    <style>
      .${this.name} {
        position: fixed;
        width: 10px;
        height: 10px;
        left: 10px;
        bottom: 10px;
        z-index: 9998;
        margin: 10px;
        padding: 5px;
        transition: opacity ease 1500ms;
        pointer-events: none;
        border-radius: 50%;
      }

      ${(0, indicator_pulse_cjs_1.pulse)(`${this.name}__success`, this.colors.success)}
      ${(0, indicator_pulse_cjs_1.pulse)(`${this.name}__error`, this.colors.error)}
      ${(0, indicator_pulse_cjs_1.pulse)(`${this.name}__warning`, this.colors.warn)}
      ${(0, indicator_pulse_cjs_1.pulse)(`${this.name}__pending`, this.colors.pending)}

      .${this.name}__visible {
        opacity: 1;
      }

      .${this.name}__hidden {
        opacity: 0;
      }
    </style>
    `;
    }
    /**
     * Show status indicator
     * @public
     */
    show() {
        clearTimeout(this.hideTimeout);
        this.classList.remove(`${this.name}__hidden`);
    }
    /**
     * Hide status indicator
     */
    hide() {
        this.hideTimeout = setTimeout(() => {
            this.classList.remove(`${this.name}__error`, `${this.name}__warning`, `${this.name}__success`, `${this.name}__pending`);
            this.classList.add(`${this.name}__hidden`);
        }, 2000);
    }
    /**
     * Status is pending
     * @public
     */
    onPending() {
        this.show();
        this.classList.remove(`${this.name}__error`, `${this.name}__warning`, `${this.name}__success`);
        this.classList.add(`${this.name}__pending`);
        this.hide();
    }
    /**
     * Status is success
     * @public
     */
    onSuccess() {
        this.show();
        this.classList.remove(`${this.name}__error`, `${this.name}__warning`, `${this.name}__pending`);
        this.classList.add(`${this.name}__success`);
        this.hide();
    }
    /**
     * Status is error
     * @public
     */
    onError() {
        this.show();
        this.classList.remove(`${this.name}__warning`, `${this.name}__success`, `${this.name}__pending`);
        this.classList.add(`${this.name}__error`);
    }
    /**
     * Status is warning
     * @public
     */
    onWarning() {
        this.show();
        this.classList.remove(`${this.name}__error`, `${this.name}__success`, `${this.name}__pending`);
        this.classList.add(`${this.name}__warning`);
    }
    /**
     * Update status
     * @public
     */
    update() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.length)
            return this.onError();
        if ((_d = (_c = this.payload) === null || _c === void 0 ? void 0 : _c.warnings) === null || _d === void 0 ? void 0 : _d.length)
            return this.onWarning();
        if (!((_f = (_e = this.payload) === null || _e === void 0 ? void 0 : _e.errors) === null || _f === void 0 ? void 0 : _f.length) &&
            !((_h = (_g = this.payload) === null || _g === void 0 ? void 0 : _g.warnings) === null || _h === void 0 ? void 0 : _h.length) &&
            this.payload.action == 'built')
            return this.onSuccess();
        if (((_j = this.payload) === null || _j === void 0 ? void 0 : _j.action) == 'building' ||
            ((_k = this.payload) === null || _k === void 0 ? void 0 : _k.action) == 'sync')
            return this.onPending();
    }
    static get observedAttributes() {
        return ['has-errors', 'has-warnings', 'action'];
    }
    attributeChangedCallback() {
        this.update();
    }
    connectedCallback() {
        if (!this.rendered) {
            this.render();
            this.rendered = true;
        }
    }
}
exports.Component = Component;
//# sourceMappingURL=indicator.component.cjs.map